module.exports = __webpack_public_path__ + "static/media/menu-logo-mob.93827744.svg";